module.exports = __webpack_public_path__ + "img/vdma_burri.d6939bb9.png";